import React, { useCallback, useEffect, useState } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import LlmModelDialog from "./LlmModelForm";
import ToolBar from "../../components/Layout/ToolBar";
import useTable from '../../components/useTable';
import * as llmModelService from '../../services/llmModelService';
import ActionsTableCell from '../../components/MaterialTable/ActionsTableCell';
import useAlert from '../../components/useAlert';
import useLinearProgress from '../../components/useLinearProgress';
import AlertDialog from '../../components/AlertDialog';

const llmModelColumns = [
    { id: 'id', label: 'ID' },
    { id: 'provider', label: 'Provider' },
    { id: 'name', label: 'Name' },
    { id: 'version', label: 'Version' },
];

const LLM_MODEL_DIALOGS = {
    CREATE_EDIT_DIALOG: 'llm_model',
    CONFIRMATION_DIALOG: 'alert'
}

const LlmModels = () => {
    const [llmModels, setLlmModels] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [dialogType, setDialogType] = useState("");

    const {
        TblContainer,
        TblHead
    } = useTable(llmModels, llmModelColumns);

    const {
        Alert,
        status,
        showSuccess,
        showError
    } = useAlert();

    const {
        LinearPorgress,
        isLoading,
        setIsLoading
    } = useLinearProgress(true);

    const getLlmModels = useCallback(() => {
        llmModelService.getLlmModels()
            .then((response) => {
                const result = response.data.items;
                setLlmModels(result || []);
            })
            .catch(error => {
                showError(error.response?.data?.message || "Error fetching LLM Models");
            }).finally(() => {
                setIsLoading(false);
            });
    }, [showError, setIsLoading]);

    useEffect(() => {
        getLlmModels();
    }, [getLlmModels]);

    const handleDeleteClicked = () => {
        llmModelService.removeLlmModel(selectedRow.id)
            .then(() => {
                showSuccess();
                getLlmModels();
            }).catch(error => {
                showError(error.response?.data?.message || "Error deleting LLM Model");
            });
    }

    return (
        <React.Fragment>
            {status ? <Alert /> : null}
            <ToolBar
                title="Add LLM Model"
                setOpen={() => {
                    setSelectedRow(null);
                    setDialogType(LLM_MODEL_DIALOGS.CREATE_EDIT_DIALOG);
                    setOpen(true);
                }}
            />
            {isLoading ? <LinearPorgress /> :
            <TblContainer>
                <TblHead />
                <TableBody>
                    {llmModels && llmModels.map(key => (
                        <TableRow
                            key={key.id}
                            onClick={() => setSelectedRow(key)}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell >{key.id}</TableCell>
                            <TableCell >{key.provider.name} ({key.provider.id})</TableCell>
                            <TableCell >{key.name}</TableCell>
                            <TableCell >{key.version}</TableCell>
                            <ActionsTableCell
                                onEdit={() => {
                                    setDialogType(LLM_MODEL_DIALOGS.CREATE_EDIT_DIALOG);
                                    setOpen(true);
                                }}
                                onDelete={(e) => {
                                    setDialogType(LLM_MODEL_DIALOGS.CONFIRMATION_DIALOG);
                                    setOpen(true);
                                }}
                            />
                        </TableRow>
                    ))}
                </TableBody>
            </TblContainer>}
            {dialogType === LLM_MODEL_DIALOGS.CREATE_EDIT_DIALOG ?
                <LlmModelDialog
                    open={open}
                    setOpen={setOpen}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    getLlmModels={getLlmModels}
                />
                : dialogType === LLM_MODEL_DIALOGS.CONFIRMATION_DIALOG ?
                    <AlertDialog
                        open={open}
                        setOpen={setOpen}
                        setSelectedRow={setSelectedRow}
                        confirmAction={handleDeleteClicked}
                    />
                    : null
            }
        </React.Fragment>
    );
}

export default LlmModels;
